import { format } from 'date-fns';
import { getDate } from './date';

export class Format {
  public static Date(value: Date | undefined): string {
    const date = getDate(value);
    return !!date ? format(date, 'MM/dd/yyyy') : '';
  }

  public static DateTime(value: Date | undefined): string {
    const date = getDate(value);
    return !!date ? format(date, 'MM/dd/yyyy h:mm:ss a') : '';
  }

  public static DateTimeCustomFormat(value: Date | undefined, exp = 'MM/dd/yyyy h:mm a'): string {
    const date = getDate(value);
    return !!date ? format(date, exp) : '';
  }

  public static MilitaryTime(value: Date): string {
    return value.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  public static StandardTime(value: Date): string {
    return value
      .toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
      .toUpperCase();
  }

  public static Money(value: string | number | null | undefined): string {
    return value != null && value !== '' ? `$${Format.Number(value)}` : '';
  }

  public static PhoneNumber = (phone: string | null | undefined): string => {
    if (!phone) {
      return phone ?? '';
    }
    //Check if the input is of correct length
    const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? '(' + match[1] + ') ' + match[2] + '-' + match[3] : phone;
  };

  public static Number = (
    value: number | string | null | undefined,
    minFractionDigits?: number
  ): string => {
    if (value == null || value === '') {
      return '';
    }
    return (typeof value === 'string' ? parseFloat(value) : value).toLocaleString('en-US', {
      minimumFractionDigits: minFractionDigits && minFractionDigits > 0 ? minFractionDigits : 0,
      maximumFractionDigits: 2
    });
  };
}
